export const actions = {
    SET_DATA: 'SET_DATA',
    SET_CARD_DATA: 'SET_CARD_DATA',
    GET_DATA: 'GET_DATA',
    UPDATE_DATA: 'UPDATE_DATA',
    ADD_WALLET_BALANCE: 'ADD_WALLET_BALANCE',
};
